import React, { useEffect, useState } from "react";
import { fetchCustomerDetails } from "../../api";
import Pagination from "../../components/Pagination/Pagination";
import "./CustomerPurchaseList.css";

const CustomerPurchaseList = () => {
  const [purchases, setPurchases] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;
  const customerId = localStorage.getItem("customerId");

  useEffect(() => {
    const fetchPurchases = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Authentication token not found.");
        const response = await fetchCustomerDetails(token);
        setPurchases(response.data.purchases);
      } catch (error) {
        console.error("Error fetching purchases:", error);
      }
    };

    fetchPurchases();
  }, [customerId]);

  const otherPurchases = purchases.filter(
    (purchase) => purchase.product_sku !== "Stringing Service"
  );

  const totalPages = Math.ceil(otherPurchases.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const displayedItems = otherPurchases.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handlePageChange = (page) => setCurrentPage(page);

  return (
    <div className="customer-purchase-list">
      {purchases.length === 0 ? (
        <p>No purchases available.</p>
      ) : (
        <>
          <h3>Your Purchases</h3>
          <table className="purchase-table">
            <thead>
              <tr>
                <th>Invoice No</th>
                <th>Purchase Date</th>
                <th>Invoice Total</th>
                <th>Valid Until</th>
                <th>Status</th>
                <th>Product SKU</th>
              </tr>
            </thead>
            <tbody>
              {displayedItems.map((purchase, index) => (
                <tr key={index}>
                  <td>{purchase.invoice_no}</td>
                  <td>
                    {new Date(purchase.purchase_date).toLocaleDateString(
                      "en-GB",
                      {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      }
                    )}
                  </td>
                  <td>{purchase.invoice_total}</td>
                  <td>
                    {new Date(purchase.valid_until).toLocaleDateString(
                      "en-GB",
                      {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      }
                    )}
                  </td>
                  <td>{purchase.status}</td>
                  <td>{purchase.product_sku}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {otherPurchases.length > itemsPerPage && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </>
      )}
    </div>
  );
};

export default CustomerPurchaseList;
